<!-- Payermax Dropin -->
<script lang="ts" setup>
import { onMounted, ref } from 'vue'
import { PaymentOrderInfo } from '../../apis/types/payment'
import PayButton from '../../components/PayButton.vue'

interface Props {
  orderInfo: PaymentOrderInfo
  dropinInstance: any
}
const props = defineProps<Props>()
interface Emits {
  (e: 'payButtonClick'): void
  (e: 'loaded'): void
  (e: 'error', error: any): void
}
const emit = defineEmits<Emits>()

const cardLoaded = ref(false)
const payButtonEnabled = ref(false)

const containerId = 'payermax-container-' + props.orderInfo.sys_order_id
const dropinInstance = props.dropinInstance

const init = () => {
  dropinInstance.mount(`#${containerId}`)

  console.log('dropinInstance :>> ', dropinInstance)
  dropinInstance.on('ready', (data) => {
    console.log('ready :>> ', data)
  })

  dropinInstance.on('load', (load) => {
    console.log('load :>> ', load, window.PMdropin.on)

    if (load.code === 'SUCCESS') {
      cardLoaded.value = true
      emit('loaded')
    } else {
      emit('error', new Error(load.msg))
    }
  })

  dropinInstance.on('form-check', (event) => {
    // 表单验证通过
    payButtonEnabled.value = event.isFormValid
  })
}

// 点击支付按钮
const onPayButtonClick = () => {
  if (!payButtonEnabled.value) return
  emit('payButtonClick')
}

onMounted(() => {
  init()
})
</script>

<template>
  <div :class="$style.payermaxContainer">
    <div :id="containerId" :class="$style.dropinContainer"></div>

    <PayButton
      v-if="cardLoaded"
      :class="$style.payButton"
      :orderInfo="orderInfo"
      :disabled="!payButtonEnabled"
      @click="onPayButtonClick"
    />
  </div>
</template>

<style lang="scss" module>
.payermax-container {
  width: 100%;
  height: 100%;
}
.dropinContainer {
  width: 100%;
}
.payButton {
  margin: 16px 0;
}
</style>
